import React, { useState, useEffect } from 'react';
import { useMappedState, useDispatch } from 'redux-react-hook';
import { Badge, Switch, List, Popover, Tooltip, Empty, Avatar, Spin, Select, DatePicker, Modal, Table, Divider, Input, Form, Tabs, Icon, Upload, Button, Row, Col, Card, Skeleton, message } from 'antd';
import CustomAvatar from './../components/customAvatar';
import EventsList from './../components/eventsList';
import { actionEvent, editClientNotes, updateDriveFile, uploadDrive, getVacancyById, getDrive, findContactsByName, getClient, uploadFile, editClient, createContact } from './../API';
import Flag from "react-country-flags";
import { allNations } from './../utils/countries';
import { navigate } from "@reach/router"
import { uploadFileValidator, readFileAsync } from './../utils';
import { flexCenterRight, formItemLayout, nameStyle, roleStyle } from './../theme';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faClipboard } from '@fortawesome/free-solid-svg-icons';
import { faBuilding } from '@fortawesome/free-solid-svg-icons'
import { faEdit } from '@fortawesome/free-solid-svg-icons'
import { faUserFriends } from '@fortawesome/free-solid-svg-icons'
import { faFileInvoiceDollar } from '@fortawesome/free-solid-svg-icons'
import { faFileInvoice } from '@fortawesome/free-solid-svg-icons'
import { faFolderOpen } from '@fortawesome/free-solid-svg-icons';
import { faRegistered } from '@fortawesome/free-solid-svg-icons';
import { faExternalLinkAlt } from '@fortawesome/free-solid-svg-icons';
import { faFileWord } from '@fortawesome/free-solid-svg-icons';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { modalDiv } from './../theme';
import InvoicesList from './../components/invoicesList';
import OffersList from './../components/offersList';
import parse from 'html-react-parser';

import { CKEditor } from '@ckeditor/ckeditor5-react';
import Editor from 'ckeditor5-custom-build/build/ckeditor';
import { format } from 'timeago.js';

import moment from 'moment';
import { s3, editorConfig } from './../utils';

const { TabPane } = Tabs;
const { Search, TextArea } = Input;
const { Option } = Select;

const CreateContact = ({form}) => {
  const dispatch = useDispatch();
  const session = useMappedState(state => state.session);
  const client = useMappedState(state => state.client);
  const { getFieldDecorator } = form;

  const [createLoading, setCreateLoading] = useState(false);
  const [showDuplatedContactModal, setShowDuplatedContactModal] = useState(false);
  const [contactsData, setContactsData] = useState([]);
  const [continueLoading, setContinueLoading] = useState(false);

  const contactSelection = [];
  for (let i = 0; i < contactsData.length; i++) {
    contactSelection.push(
    <Row
      key={i}
      style={{
      marginTop: '5px',
      marginBottom: '5px',
    }}>
      <Col span={2}>
        <CustomAvatar
          colourCode={contactsData[i].firstname.charAt(0).toLowerCase()}
          char={`${contactsData[i].firstname.charAt(0).toUpperCase()}${contactsData[i].lastname.charAt(0).toUpperCase()}`}
          charSize={12}
          src={contactsData[i].avatar}
        />
      </Col>
      <Col span={1}>
        {contactsData[i].salutation ? contactsData[i].salutation : null}
      </Col>

      <Col span={6}>
        {`${contactsData[i].firstname} ${contactsData[i].lastname}`}
      </Col>
      <Col span={6}>
        {
          contactsData[i].dob ?
          moment(contactsData[i].dob).format('YYYY-MM-DD')
          :
          null
        }
      </Col>
      <Col span={4}>
        {contactsData[i].position ? contactsData[i].position : null}
      </Col>
    </Row>
    );
  }

  const handleCreateContinue = async e => {
    e.preventDefault();
    const formResult = await form.validateFields();
    setContinueLoading(true);

    const result = await createContact(session.authToken, {
      ...formResult,
      ...{firstname: formResult.firstname.trim(), lastname: formResult.lastname.trim()},
      ...{clientID: client.id}
    });
    if (result.data.responseCode === 0) {
      const response = await getClient(session.authToken, client.id);
      dispatch({type: "INIT_CLIENT", payload: response.data.client});
      setContinueLoading(false);
      setShowDuplatedContactModal(false);
      dispatch({
        type: "SET_CREATE_CONTACT_MODAL",
        payload: false
      });
      form.resetFields();
      message.success(result.data.message);
    }
    else {
      setContinueLoading(false);
      dispatch({type: "OPEN_MSG_MODAL", payload: result.data.message});
    }
  }

  const handleCreateSubmit = async e => {
    e.preventDefault();
    const formResult = await form.validateFields();
    setCreateLoading(true);

    //check if any contact has same firstname and lastname
    const dcontacts = await findContactsByName(
      session.authToken,
      formResult.firstname.trim(),
      formResult.lastname.trim()
      )

    if (dcontacts.data.responseCode === 0) {
      if (dcontacts.data.contacts.length > 0) {
        setContactsData(dcontacts.data.contacts);
        setCreateLoading(false);
        setShowDuplatedContactModal(true);
      }
      else {
        const result = await createContact(session.authToken, {
          ...formResult,
          ...{firstname: formResult.firstname.trim(), lastname: formResult.lastname.trim()},
          ...{clientID: client.id}
        });
        if (result.data.responseCode === 0) {
          const response = await getClient(session.authToken, client.id);
          dispatch({type: "INIT_CLIENT", payload: response.data.client});
          setCreateLoading(false);
          dispatch({
            type: "SET_CREATE_CONTACT_MODAL",
            payload: false
          });
          form.resetFields();
          message.success(result.data.message);
        }
        else {
          setCreateLoading(false);
          dispatch({type: "OPEN_MSG_MODAL", payload: result.data.message});
        }
      }
    }
    else{
      setCreateLoading(false);
      dispatch({type: "OPEN_MSG_MODAL", payload: dcontacts.data.message});
    }
  };

  return(
    <React.Fragment>
    <Modal
      centered={true}
      title="Duplicated Contacts Warning"
      closable={false}
      visible={showDuplatedContactModal}
      width={600}
      footer={[
        <Button key="cancel" onClick={() => {
          setShowDuplatedContactModal(false);
          dispatch({
            type: "SET_CREATE_CONTACT_MODAL",
            payload: false
          });
          form.resetFields();
        }}>
          <Icon type="close" />
          Cancel
        </Button>,
        <Button key="create" type="primary" onClick={handleCreateContinue}>
          {continueLoading ? <Icon type="loading" /> : <Icon type="check" />}
          Continue
        </Button>
      ]}
    >
      <div>
      <Icon type="warning" theme="twoTone" twoToneColor="red" style={{fontSize: "24px"}}/>
      &nbsp;&nbsp;
      All duplicated contacts show below
      <br/><br/>
      </div>
      {contactSelection}
    </Modal>
    <Modal
      centered={true}
      title="Create New Contact"
      closable={false}
      visible={client.showCreateContactModal}
      width="90%"
      footer={[
        <Button disabled={createLoading} key="cancel" onClick={() => {
          dispatch({
            type: "SET_CREATE_CONTACT_MODAL",
            payload: false
          });
          form.resetFields();
        }}>
          <Icon type="close" />
          Cancel
        </Button>,
        <Button key="create" type="primary" onClick={handleCreateSubmit}>
          {createLoading ? <Icon type="loading" /> : <Icon type="check" />}
          Submit
        </Button>
      ]}
    >
    <div style={modalDiv}>
      <Form>
        <Row>
          <Col span={12}>
            <Form.Item {...formItemLayout} label="Salutation">
              {getFieldDecorator('salutation', {})(
                <Select
                  disabled={createLoading}
                  placeholder="Salutation"
                >
                  <Option value="Mr">Mr</Option>
                  <Option value="Ms">Ms</Option>
                </Select>
              )}
            </Form.Item>

            <Form.Item {...formItemLayout} label="First Name">
              {getFieldDecorator('firstname', {
                rules: [{ required: true, message: 'Please input firstname!' }],
              })(
                <Input autoComplete="off" placeholder="First Name" disabled={createLoading} />
              )}
            </Form.Item>

            <Form.Item {...formItemLayout} label="Last Name">
              {getFieldDecorator('lastname', {
                rules: [{ required: true, message: 'Please input lastname!' }],
              })(
                <Input autoComplete="off" placeholder="Last Name" disabled={createLoading} />
              )}
            </Form.Item>

            <Form.Item {...formItemLayout} label="Birthday">
              {getFieldDecorator('dob', {})(
                <DatePicker placeholder="Date of Birth" style={{width: "100%"}} disabled={createLoading} />
              )}
            </Form.Item>

            <Form.Item {...formItemLayout} label="Email">
              {getFieldDecorator('email', {
                rules: [
                  {
                    type: "email",
                    message: "Please input valid email!",
                  },
                  {
                    required: true,
                    message: 'Please input email!'
                  }
                ],
              })(
                <Input autoComplete="off" placeholder="Email" disabled={createLoading} />
              )}
            </Form.Item>

            <Form.Item {...formItemLayout} label="Optional Email 1">
              {getFieldDecorator('email1', {
                rules: [
                  {
                    type: "email",
                    message: "Please input valid email!",
                  }
                ],
              })(
                <Input autoComplete="off" placeholder="Optional Email 1" disabled={createLoading} />
              )}
            </Form.Item>

            <Form.Item {...formItemLayout} label="Optional Email 2">
              {getFieldDecorator('email2', {
                rules: [
                  {
                    type: "email",
                    message: "Please input valid email!",
                  }
                ],
              })(
                <Input autoComplete="off" placeholder="Optional Email 2" disabled={createLoading} />
              )}
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item {...formItemLayout} label="Mobile">
              {getFieldDecorator('mobile', {})(
                <Input autoComplete="off" placeholder="Mobile" disabled={createLoading} />
              )}
            </Form.Item>

            <Form.Item {...formItemLayout} label="Landline">
              {getFieldDecorator('tel', {})(
                <Input autoComplete="off" placeholder="Landline" disabled={createLoading} />
              )}
            </Form.Item>

            <Form.Item {...formItemLayout} label="Department">
              {getFieldDecorator('department', {})(
                <Input autoComplete="off" placeholder="Department" disabled={createLoading} />
              )}
            </Form.Item>

            <Form.Item {...formItemLayout} label="Position">
              {getFieldDecorator('position', {})(
                <Input autoComplete="off" placeholder="Position" disabled={createLoading} />
              )}
            </Form.Item>

            <Form.Item {...formItemLayout} label="LinkedIn">
              {getFieldDecorator('linkedin', {})(
                <Input autoComplete="off" placeholder="Linkedin" disabled={createLoading} />
              )}
            </Form.Item>

            <Form.Item {...formItemLayout} label="Wechat">
              {getFieldDecorator('wechat', {})(
                <Input autoComplete="off" placeholder="Wechat" disabled={createLoading} />
              )}
            </Form.Item>

            <Form.Item {...formItemLayout} label="Whats app">
              {getFieldDecorator('whatsapp', {})(
                <Input autoComplete="off" placeholder="Whats app" disabled={createLoading} />
              )}
            </Form.Item>

            <Form.Item {...formItemLayout} label="Other Contact">
              {getFieldDecorator('othercontact', {})(
                <Input autoComplete="off" placeholder="Other Contact" disabled={createLoading} />
              )}
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </div>
    </Modal>
    </React.Fragment>
  )
}

const CreateContactForm = Form.create({ name: 'create-contact' })(CreateContact);

const EditClient = ({form}) => {
  const nations = allNations();
  const dispatch = useDispatch();
  const session = useMappedState(state => state.session);
  const client = useMappedState(state => state.client);
  const { getFieldDecorator } = form;

  const [editLoading, setEditLoading] = useState(false);

  const handleSubmit = async e => {
    e.preventDefault();
    const formResult = await form.validateFields();
    setEditLoading(true);

    const requestData = {
      id: client.id,
      name: formResult.name.trim(),
      tel: formResult.landline,
      website: formResult.website,
      jobs: formResult.jobs,
      tob: formResult.tob,
      invoiceClientName: formResult.invoiceClientName,
      address: {
        address1: formResult.address1,
        address2: formResult.address2,
        city: formResult.city,
        country: formResult.country,
        postcode: formResult.postcode
      },
      invoiceAddress: {
        address1: formResult.invoiceAddress1,
        address2: formResult.invoiceAddress2,
        city: formResult.invoiceCity,
        country: formResult.invoiceCountry,
        postcode: formResult.invoicePostcode
      }
    }

    const result = await editClient(session.authToken, requestData);
    setEditLoading(false);
    if (result.data.responseCode === 0) {
      dispatch({
        type: "INIT_CLIENT",
        payload: {
          ...requestData,
          ...{contacts: client.contacts, avatar: client.avatar}
        }
      });
      message.success(result.data.message);
    }
    else {
      dispatch({type: "OPEN_MSG_MODAL", payload: result.data.message});
    }
  };

  const countrySelection = [];
  for (let i = 0; i < nations.length; i++) {
    countrySelection.push(
      <Option key={i} value={nations[i].name} label={nations[i].name}>
        <Row>
          <Col span={4}>
            <Flag country={nations[i].code} asSquare={true} style={{width: '30px', height: '20px'}}/>
          </Col>
          <Col>
            {nations[i].name}
          </Col>
        </Row>
      </Option>
    )
  }

  return(
    <Form onSubmit={handleSubmit}>
      <Row>
        <Col span={12}>
          <Form.Item {...formItemLayout} label="Name">
            {getFieldDecorator('name', {
              initialValue: client.name,
              rules: [{ required: true, message: 'Please input name!' }],
            })(
              <Input autoComplete="off" placeholder="Name" disabled={editLoading} />
            )}
          </Form.Item>

          <Form.Item {...formItemLayout} label="Landline">
            {getFieldDecorator('landline', {
              initialValue: client.tel ? client.tel : "",
            })(
              <Input autoComplete="off" placeholder="Landline" disabled={editLoading} />
            )}
          </Form.Item>

          <Form.Item {...formItemLayout} label="Website">
            {getFieldDecorator('website', {
              initialValue: client.website ? client.website : "",
            })(
              <Input autoComplete="off" placeholder="Website" disabled={editLoading} />
            )}
          </Form.Item>

          <Form.Item {...formItemLayout} label="Jobs Website">
            {getFieldDecorator('jobs', {
              initialValue: client.jobs ? client.jobs : "",
            })(
              <Input autoComplete="off" placeholder="Jobs Website" disabled={editLoading} />
            )}
          </Form.Item>

          <Form.Item {...formItemLayout} label="Term">
            {getFieldDecorator('tob', {
              initialValue: client.tob ? client.tob : ""
            })(
              <TextArea rows={4} placeholder="Term of Business" disabled={editLoading} />
            )}
          </Form.Item>

        </Col>
        <Col span={12}>
          <Form.Item {...formItemLayout} label="Address 1">
            {getFieldDecorator('address1', {
              initialValue: client.address ? client.address.address1 : "",
            })(
              <Input autoComplete="off" placeholder="Address 1" disabled={editLoading} />
            )}
          </Form.Item>

          <Form.Item {...formItemLayout} label="Address 2">
            {getFieldDecorator('address2', {
              initialValue: client.address ? client.address.address2 : "",
            })(
              <Input autoComplete="off" placeholder="Address 2" disabled={editLoading} />
            )}
          </Form.Item>

          <Form.Item {...formItemLayout} label="City">
            {getFieldDecorator('city', {
              initialValue: client.address ? client.address.city : "",
              rules: [{ required: true, message: 'Please input city!' }],
            })(
              <Input autoComplete="off" placeholder="City" disabled={editLoading} />
            )}
          </Form.Item>

          <Form.Item {...formItemLayout} label="Country">
            {getFieldDecorator('country', {
              initialValue: client.address ? client.address.country : "",
            })(
              <Select
                disabled={editLoading}
                placeholder="Country"
                optionLabelProp="label"
                showSearch
              >
              {countrySelection}
              </Select>
            )}
          </Form.Item>

          <Form.Item {...formItemLayout} label="Post Code">
            {getFieldDecorator('postcode', {
              initialValue: client.address ? client.address.postcode : "",
            })(
              <Input autoComplete="off" placeholder="Post Code" disabled={editLoading} />
            )}
          </Form.Item>
        </Col>
      </Row>

      <Divider />
      <div style={{marginLeft: '10px'}}>
        <b>Invoice Address</b>
      </div>
      <br/>

      <Row>
        <Col span={12}>
          <div style={{marginRight: '10px'}}>
            <Form.Item {...formItemLayout} label="Client Name">
              {getFieldDecorator('invoiceClientName', {
                initialValue: client.invoiceClientName ? client.invoiceClientName : "",
              })(
                <Input autoComplete="off" placeholder="Client Name" disabled={editLoading} />
              )}
            </Form.Item>

            <Form.Item {...formItemLayout} label="City">
              {getFieldDecorator('invoiceCity', {
                initialValue: client.invoiceAddress ? client.invoiceAddress.city : "",
              })(
                <Input autoComplete="off" placeholder="City" disabled={editLoading} />
              )}
            </Form.Item>

            <Form.Item {...formItemLayout} label="Country">
              {getFieldDecorator('invoiceCountry', {
                initialValue: client.invoiceAddress ? client.invoiceAddress.country : "",
              })(
                <Select
                  disabled={editLoading}
                  placeholder="Country"
                  optionLabelProp="label"
                  showSearch
                >
                {countrySelection}
                </Select>
              )}
            </Form.Item>
          </div>
        </Col>
        <Col span={12}>
          <div style={{marginLeft: '10px'}}>
            <Form.Item {...formItemLayout} label="Address 1">
                {getFieldDecorator('invoiceAddress1', {
                  initialValue: client.invoiceAddress ? client.invoiceAddress.address1 : "",
                })(
                  <Input autoComplete="off" placeholder="Address 1" disabled={editLoading} />
                )}
            </Form.Item>

            <Form.Item {...formItemLayout} label="Address 2">
              {getFieldDecorator('invoiceAddress2', {
                initialValue: client.invoiceAddress ? client.invoiceAddress.address2 : "",
              })(
                <Input autoComplete="off" placeholder="Address 2" disabled={editLoading} />
              )}
            </Form.Item>

            <Form.Item {...formItemLayout} label="Post Code">
              {getFieldDecorator('invoicePostcode', {
                initialValue: client.invoiceAddress ? client.invoiceAddress.postcode : "",
              })(
                <Input autoComplete="off" placeholder="Post Code" disabled={editLoading} />
              )}
            </Form.Item>
          </div>
        </Col>
      </Row>

      <div style={flexCenterRight}>
        <Form.Item>
          <Button type="primary" htmlType="submit">
            {editLoading ? <Icon type="loading" /> : <Icon type="check" />}
            Submit
          </Button>
        </Form.Item>
      </div>

    </Form>
  )
}

const EditClientForm = Form.create({ name: 'edit-client' })(EditClient);

function Client(props) {
  const session = useMappedState(state => state.session);
  const client = useMappedState(state => state.client);
  const dispatch = useDispatch();

  const [updateFileDetail, setUpdateFileDetail] = useState(null);
  const [showUpdateFileModal, setShowUpdateFileModal] = useState(false);
  const [showUploadModal, setShowUploadModal] = useState(false);

  const [showNotesModal, setShowNotesModal] = useState(false);
  const [notes, setNotes] = useState(null);
  const [notesLoading, setNotesLoading] = useState(false);

  const [loading, setLoading] = useState(true);
  const [avatarLoading, setAvatarLoading] = useState(false);
  const [search, setSearch] = useState("");

  const [fileSearch, setFileSearch] = useState("");
  const [files, setFiles] = useState([]);

  const [driveRefetching, setDriveRefetching] = useState(false);

  const [vacancyEvents, setVacancyEvents] = useState([]);
  const [vacancyLoading, setVacancyLoading] = useState(false);

  const [showEditVacancyModal, setShowEditVacancyModal] = useState(false);
  const [vacancyEventEntry, setVacancyEventEntry] = useState(null);

  const [showVacancyDetailModal, setShowVacancyDetailModal] = useState(false);
  const [vacancyDetailLoading, setVacancyDetailLoading] = useState(false);
  const [vacancyDetailData, setVacancyDetailData] = useState([]);

  useEffect(() => {
    async function fetchData() {
      dispatch({type: "CLEAR_CLIENT"});
      const response = await getClient(session.authToken, props.id);

      if (response.data.responseCode === 0) {
        setNotes(response.data.client.notes);

        let dataVacancy;
        if (response.data.vacancyEvents) {
          dataVacancy = response.data.vacancyEvents.map(i => {
            return {
              ...i,
              ...{ contactAvatarUrl: i.contact_doc ? `${s3.baseURL}/${process.env.REACT_APP_S3_BUCKET}/avatar/contact/${i.contact_doc.id}.jpeg` : '' }
            }
          })
        }
        setVacancyEvents(dataVacancy);

        dispatch({type: "INIT_CLIENT", payload: response.data.client});
        const responseDrive = await getDrive(session.authToken, response.data.client.driveFolderID);
        setFiles(responseDrive.data.data);
        setLoading(false);
      }
      else {
        navigate(`/clients`);
        message.error(response.data.message);
      }

    }
    dispatch({type: "SET_INDEX", payload: "3"});
    fetchData();
  // eslint-disable-next-line
  }, []);

  const columns = [
    {
      title: '',
      width: '1%',
      key: 'avatar',
      render: contact =>
        <CustomAvatar
          colourCode={contact.firstname.charAt(0).toLowerCase()}
          char={`${contact.firstname.charAt(0).toUpperCase()}${contact.lastname.charAt(0).toUpperCase()}`}
          charSize={12}
          src={contact.avatar}
        />
    },
    {
      title: '',
      width: '1%',
      dataIndex: 'salutation',
      key: 'salutation',
    },
    {
      title: 'Name',
      width: '8%',
      dataIndex: 'fullname',
      sorter: (a, b) => a.fullname.localeCompare(b.fullname),
      key: 'fullname',
      render: fullname => <span>{fullname}</span>
    },
    {
      title: 'Position',
      width: '8%',
      sorter: (a, b) => a.position.localeCompare(b.position),
      dataIndex: 'position',
      key: 'position',
    },
    {
      title: 'Department',
      width: '8%',
      sorter: (a, b) => a.department.localeCompare(b.department),
      dataIndex: 'department',
      key: 'department',
    },
    {
      title: '',
      width: '5%',
      render: contact => <div style={flexCenterRight}>
        <Button size="small" onClick={() => {
          navigate(`/contacts/${contact.id}`)
        }}><Icon type="plus" /> Details</Button>
      </div>
    }
  ];

  const cardTitle = (
    <center>
      {
        client.name ?
        !avatarLoading ?
        <CustomAvatar
          colourCode={client.name.charAt(0).toLowerCase()}
          char={`${client.name.charAt(0).toUpperCase()}`}
          charSize={30}
          size={86}
          src={client.avatar}
        />
        :
        <Avatar size={86} style={{backgroundColor: '#eeeeee'}}>
            <Spin indicator={<Icon type="loading" style={{fontSize: 24}} />} />
        </Avatar>
        :
        null
      }
      <>
      <div style={{marginTop: "15px"}}>
        <p style={nameStyle}>
          {client.name}
        </p>
        {
          client.website && client.website !== "" ?
          <p style={roleStyle} onClick={() => {
            window.open(client.website, '_blank');
          }}>
            <span style={{cursor: "pointer"}}>go to website</span>
          </p>
          :
          null
        }

        <Upload
          beforeUpload={(file) => {
            return uploadFileValidator(message, file, ['image/jpeg'], 4);
          }}
          showUploadList={false}
          customRequest={(e) => {
          setAvatarLoading(true);
          var reader  = new FileReader();
          reader.readAsDataURL(e.file);

          reader.onload = function() {
            const imageData = reader.result.replace("data:image/jpeg;base64,", "")
            uploadFile(session.authToken,
              {file: imageData, name: `avatar/client/${client.id}.jpeg`, acl: 'public-read'}).then(x => {
                setAvatarLoading(false);
                e.onSuccess();
                dispatch({type: "UPDATE_CLIENT_AVATAR"});
            })
          }
        }}>
          <Button size="small">
            {avatarLoading ? <Icon type="loading" /> : <Icon type="upload" />}Upload Avatar
          </Button>
        </Upload>

      </div>
      </>
    </center>
  )

  const UpdateFile = ({form}) => {
    const { getFieldDecorator } = form;
    const [updating, setUpdating] = useState(false);

    let splitName = null;
    let suffix = "";
    let name = "";

    if (updateFileDetail) {
      if (updateFileDetail.exportLinks) {
        name = updateFileDetail.name;
      }
      else {
        splitName = updateFileDetail.name.split(".");
        suffix = "."+splitName[splitName.length-1];
        splitName.pop();
        name = splitName.join(".");
      }
    }

    const handleOnClickUpdateFile = async () => {
      const formResult = await form.validateFields();
      setUpdating(true);
      const response = await updateDriveFile(session.authToken, {
        fileID: updateFileDetail.id,
        fileName: updateFileDetail.exportLinks ? formResult.updateFile : formResult.updateFile+suffix,
        starred: false
      });

      if (response.data.responseCode === 0) {
        setUpdating(false);
        setShowUpdateFileModal(false);
        message.success(response.data.message)

        setDriveRefetching(true);
        const driveResult = await getDrive(session.authToken, client.driveFolderID);
        setFiles(driveResult.data.data);
        setDriveRefetching(false);
      }
      else {
        setUpdating(false);
        message.error(response.data.message);
      }
    }

    return(
      <Modal
      centered={true}
      title="Edit Document"
      closable={false}
      visible={showUpdateFileModal}
      width={600}
      footer={[
        <Button
          disabled={updating}
          key="close" onClick={() => {
            setShowUpdateFileModal(false);
            setUpdateFileDetail(null);
        }}>
          <Icon type="close" />
          Close
        </Button>,
        <Button
          key="update"
          type="primary"
          onClick={handleOnClickUpdateFile}
        >
          {updating ? <Icon type="loading" /> : <Icon type="check" />}
          Update
        </Button>
      ]}
    >
      <div>
        {
         updateFileDetail ?
         <div>
          <Form.Item label="Document Name">
            {getFieldDecorator('updateFile', {
              initialValue: name,
              rules: [{ required: true, message: 'Please input document name!' }],
            })(
              <Input
                suffix={updateFileDetail.exportLinks ? ".GoogleDocFile" : suffix}
                placeholder="Document Name"
                disabled={updating}
              />
            )}
          </Form.Item>
         </div>
         :
         null
        }
      </div>
    </Modal>
    )
  }
  const UpdateFileForm = Form.create({ name: 'update-file' })(UpdateFile);

  const UploadDocument = () => {
    const [uploadFiles, setUploadFiles] = useState([]);
    const [docUploading, setDocUploading] = useState(false);

    const handleOnClickUploadDocuments = async () => {
      setDocUploading(true);

      const fileList = [];
      for (const each of uploadFiles) {
        const file = await readFileAsync(each)
        fileList.push({
          name: each.name,
          type: each.type,
          data: file.replace(/data:.+,/, ""),
        })
      }

      await uploadDrive(
        session.authToken,
        {
          driveFolder: client.driveFolderID,
          files: fileList,
        }
      );
      setDocUploading(false);
      setShowUploadModal(false);
      message.success('Upload files finished');

      setDriveRefetching(true);
      const driveResult = await getDrive(session.authToken, client.driveFolderID);
      setFiles(driveResult.data.data);
      setDriveRefetching(false);
    }

    return(
      <Modal
      centered={true}
      title="Upload Documents"
      closable={false}
      visible={showUploadModal}
      width={525}
      footer={[
        <Button
          disabled={docUploading}
          key="close" onClick={() => {
          setShowUploadModal(false);
        }}>
          <Icon type="close" />
          Close
        </Button>,
        <Button
          disabled={uploadFiles.length === 0}
          key="upload"
          type="primary"
          onClick={handleOnClickUploadDocuments}
        >
          {docUploading ? <Icon type="loading" /> : <Icon type="upload" />}
          Upload
        </Button>
      ]}
    >
      <Upload {...{
        accept: 'image/*,.pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx',
        multiple: true,
        onRemove: file => {
          setUploadFiles(uploadFiles.filter(i => i.uid !== file.uid));
        },
        beforeUpload: (_, fileList) => {
          setUploadFiles([...uploadFiles, ...fileList])
          return false;
        },
        uploadFiles,
      }}>
        <Button disabled={docUploading} >
          <Icon type="file" /> Select
        </Button>
        &nbsp;&nbsp;
        <i style={{color: '#bbb'}}>Allowed file: image, pdf, doc, docx, xls, xlsx, ppt, pptx</i>
      </Upload>
      <br/>
    </Modal>
    )
  }

  const fileColumns = [
    {
      title: 'Name',
      width: '70%',
      key: 'name',
      sorter: (a, b) => a.name.localeCompare(b.name),
      render: file =>
      <div>
        <img
          src={file.iconLink}
          alt={file.name}
        />
        &nbsp;
        {file.name}
      </div>
    },
    {
      title: 'Date',
      width: '20%',
      key: 'date',
      sorter: (a, b) => a.createdTime.localeCompare(b.createdTime),
      render: file =>
      <div>
        {moment(file.createdTime).format("DD/MM/YY HH:mm")}
      </div>
    },
    {
      title: '',
      width: '5%',
      key: 'edit',
      render: file =>
      <div>
      <Tooltip title={"Edit"}>
        <FontAwesomeIcon
          onClick={() => {
            setUpdateFileDetail(file);
            setShowUpdateFileModal(true);
          }}
          style={{
            cursor: 'pointer',
          }} icon={faEdit} />
      </Tooltip>
      </div>
    },
    {
      title: '',
      width: '5%',
      key: 'view',
      render: file =>
      <div>
      <Tooltip title={"View"}>
        <FontAwesomeIcon
          onClick={() => {
            window.open(file.webViewLink,'_blank');
          }}
          style={{
            cursor: 'pointer',
          }} icon={faExternalLinkAlt} />
      </Tooltip>
      </div>
    },
  ]

  const renderVacancyEventButton = (i) => {
    if (i.user_doc.id === session.id) {
      return(
        <>
        <div style={{marginTop: '3px'}}>
          <Switch
            size="small"
            defaultChecked={i.enable}
            onChange={async () => {
              setVacancyLoading(true);
              const res = await actionEvent(
                session.authToken,
                {
                  type: 'enable/disable',
                  id: i.id,
                  value: !i.enable,
                }
              );
              if (res.data.responseCode === 0) {
                const response = await getClient(session.authToken, props.id);

                let dataVacancy;
                if (response.data.vacancyEvents) {
                  dataVacancy = response.data.vacancyEvents.map(i => {
                    return {
                      ...i,
                      ...{ contactAvatarUrl: i.contact_doc ? `${s3.baseURL}/${process.env.REACT_APP_S3_BUCKET}/avatar/contact/${i.contact_doc.id}.jpeg` : '' }
                    }
                  })
                }
                setVacancyEvents(dataVacancy);          
                message.success(res.data.message);
                setVacancyLoading(false);
              } else {
                message.error(res.data.message);
                setVacancyLoading(false);
              }
            }}
          />
        </div>
        &nbsp;&nbsp;&nbsp;
        <div style={{marginTop: '6px'}}>
          <Button size="small" onClick={() => {
              setShowEditVacancyModal(true);
              setVacancyEventEntry(i);
          }}>
            <Icon type="form" />
          </Button>
        </div>
        &nbsp;
        <div style={{marginTop: '6px'}}>
          <Button size="small" onClick={async () => {
            setShowVacancyDetailModal(true);
            setVacancyDetailLoading(true);
            const data = await getVacancyById(session.authToken, i.id);
            setVacancyDetailData(data.data.interviews);
            setVacancyDetailLoading(false);
          }}>
            <Icon type="plus" />
          </Button>
        </div>
      </>
      )
    }
    return (
      <>
        <Button size="small" onClick={async () => {
            setShowVacancyDetailModal(true);
            setVacancyDetailLoading(true);
            const data = await getVacancyById(session.authToken, i.id);
            setVacancyDetailData(data.data.interviews);
            setVacancyDetailLoading(false);
          }}>
            <Icon type="plus" />
          </Button>
          &nbsp;
          <CustomAvatar
          showTooltip={true}
          tooltipTitle={`${i.user_doc.firstname} ${i.user_doc.lastname}`}
          colourCode={i.user_doc.firstname.charAt(0).toLowerCase()}
          char={`${i.user_doc.firstname.charAt(0).toUpperCase()}${i.user_doc.lastname.charAt(0).toUpperCase()}`}
          charSize={12}
          size={30}
          src={`${s3.baseURL}/${process.env.REACT_APP_S3_BUCKET}/avatar/user/${i.user_doc.id}.jpeg`}
        />      
      </>
    )
  }

  const renderVacancyEvent = (i, index) => {
    return (
      <>
        <Row>
          <Col span={1}>
            <div style={{ marginTop: '5px' }}>{index}.</div>
          </Col>
          <Col span={10}>
            <div style={{ marginTop: '5px'}}>
              {i.title}
            </div>
          </Col>
          <Col span={1}>
            <div style={{ marginTop: '6px' }}>
            <Popover
              overlayStyle={{
                width: '50vw',
              }}
              placement="top"
              title="Vacancy Description"
              content={
                <>
                  {parse(i.body)}
                </>
              }
            >
              <FontAwesomeIcon icon={faInfoCircle} style={{ fontSize: '18px', color: '#72A0C1'}} />
            </Popover>
            </div>
          </Col>
          <Col span={6}>
            {
              i.contact_doc ?
                <React.Fragment>
                  <CustomAvatar
                    colourCode={i.contact_doc.firstname.charAt(0).toLowerCase()}
                    char={`${i.contact_doc.firstname.charAt(0).toUpperCase()}${i.contact_doc.lastname.charAt(0).toUpperCase()}`}
                    src={i.contactAvatarUrl}
                  />
                  <span onClick={() => {
                    navigate(`/contacts/${i.contact_doc.id}`)
                  }}
                    style={{ marginLeft: '5px', cursor: 'pointer', marginTop: '5px' }}>{`${i.contact_doc.firstname} ${i.contact_doc.lastname}`}
                  </span>
                </React.Fragment>
                :
                null
            }
          </Col>
          <Col span={3}>
            <div style={flexCenterRight}>
              <span style={{ marginTop: '5px', color: '#aaa', fontSize: '12px' }}>
                <i>{format(new Date(moment(i.createdAt).format('YYYY-MM-DD HH:mm:ss')))}</i>
              </span>
            </div>
          </Col>
          <Col span={3} style={flexCenterRight}>
            {renderVacancyEventButton(i)}
          </Col>
        </Row>
      </>
    )
  }

  const NewVacancy = ({form}) => {
    const { getFieldDecorator } = form;

    const [editVacancyLoading, setEditVacancyLoading] = useState(false);
    const [vacancyBody, setVacancyBody] = useState(null);


  useEffect(() => {
    setVacancyBody(vacancyEventEntry.body)
  }, []);

    return(
      <Modal
      zIndex={100}
      centered={true}
      title="Edit Vacancy"
      closable={false}
      visible={showEditVacancyModal}
      width="90%"
      footer={[
        <Button disabled={editVacancyLoading} key="cancel" onClick={() => {
          setShowEditVacancyModal(false);
          setVacancyEventEntry(null);
          setVacancyBody('');
        }}>
          <Icon type="close" />
          Cancel
        </Button>,
        <Button key="create" type="primary" onClick={async () => {
          const formResult = await form.validateFields();

          setEditVacancyLoading(true);
          const result = await actionEvent(
            session.authToken,
            {
              type: 'edit',
              id: vacancyEventEntry.id,
              title: formResult.title,
              body: vacancyBody,
            }
          );

          if (result.data.responseCode === 0) {
            const response = await getClient(session.authToken, props.id);

            let dataVacancy;
            if (response.data.vacancyEvents) {
              dataVacancy = response.data.vacancyEvents.map(i => {
                return {
                  ...i,
                  ...{ contactAvatarUrl: i.contact_doc ? `${s3.baseURL}/${process.env.REACT_APP_S3_BUCKET}/avatar/contact/${i.contact_doc.id}.jpeg` : '' }
                }
              })
            }
            setVacancyEvents(dataVacancy);

            setEditVacancyLoading(false);
            setShowEditVacancyModal(false);
            message.success(result.data.message);
          }
          else {
            setEditVacancyLoading(false);
            message.error(result.data.message.toString());
          }
        }}>
          {editVacancyLoading ? <Icon type="loading" /> : <Icon type="check" />}
          Submit
        </Button>
      ]}
    >
      <div>
        <Row>
          <Col span={24}>
            <Form.Item>
              {getFieldDecorator('title', {
                initialValue: vacancyEventEntry.title,
                rules: [{ required: true, message: 'Please input vacancy title!' }],
              })(
                <Input autoComplete="off" placeholder="Vacancy title" disabled={editVacancyLoading} />
              )}
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <CKEditor
              disabled={editVacancyLoading}
              value={vacancyBody}
              data={vacancyBody}
              editor={ Editor }
              config= { editorConfig }
              onChange={ ( event, editor ) => {
                const data = editor.getData();
                setVacancyBody(data);
              }}
            />
          </Col>
        </Row>
      </div>
    </Modal>
    )
  }

  const NewVacancyForm = Form.create({ name: 'new-vacancy' })(NewVacancy);

  return (
    loading ?
    <div>
      <p>Loading...</p>
      <Skeleton active />
    </div>
    :
    <div>

        {
          showVacancyDetailModal ? (
            <Modal
            zIndex={100}
            centered={true}
            title="Vacancy - Interview Follow Up(s)"
            closable={false}
            visible={showVacancyDetailModal}
            width="90%"
            footer={[
              <Button disabled={vacancyDetailLoading} key="cancel" onClick={() => {
                setShowVacancyDetailModal(false);
                setVacancyDetailData([]);
              }}>
                <Icon type="close" />
                Close
              </Button>,
            ]}
          >
            {
              vacancyDetailLoading ? (
                <center><Spin spinning indicator={<Icon type="loading" />} /> Loading...</center>
              ) : (
                <>
                {
                  vacancyDetailData.length > 0 ? (
                    <div style={{maxHeight: '425px', overflow: 'auto'}}><EventsList data={vacancyDetailData} /></div>
                  ) : (
                    <center><div style={{ color: '#cccccc' }}>Data Not Available</div></center>
                  )
                }
                </>
              )
            }
          </Modal>
          ) : null
        }

        {
          showEditVacancyModal ? (
            <NewVacancyForm />
          ) : null
        }
       <UpdateFileForm />
       <UploadDocument />
       <Modal
         zIndex={100}
         centered={true}
         title="Edit Client Notes"
         closable={false}
         visible={showNotesModal}
         width="90%"
         footer={[
           <Button disabled={notesLoading} key="cancel" onClick={() => {
             setShowNotesModal(false);
             if (client.notes) {
               setNotes(client.notes);
             } else {
               setNotes("");
             }
           }}>
             <Icon type="close" />
             Cancel
           </Button>,
           <Button key="edit" type="primary" onClick={() => {
             setNotesLoading(true);
             editClientNotes(
               session.authToken,
               {id: client.id, notes: notes}
             ).then(x => {

               if (x.data.responseCode === 0) {
                 dispatch({type: "UPDATE_CLIENT_NOTES", payload: notes});
                 setShowNotesModal(false);
                 setNotesLoading(false);
                 message.success("client notes update successful");
               }
               else {
                 setShowNotesModal(false);
                 setNotesLoading(false);
                 setNotes(client.notes);
                 message.error(x.data.message);
               }

             });
           }}>
             {notesLoading ? <Icon type="loading" /> : <Icon type="check" />}
             Submit
           </Button>
         ]}
       >
         <CKEditor
           disabled={notesLoading}
           value={notes}
           data={notes}
           editor={ Editor }
           config= { editorConfig }
           onChange={ ( event, editor ) => {
             const data = editor.getData();
             setNotes(data);
           }}
         />
       </Modal>
       <Row>
        <Col span={6}>
          <div style={{marginRight: '5px'}}>
            <Card title={cardTitle} bordered={true}>
              <div style={{marginTop: '-25px'}}>

              <React.Fragment>
                <br/>
                <div><FontAwesomeIcon icon={faRegistered} />&nbsp;<b>Reference</b></div>
                <div>{client.reference}</div>
              </React.Fragment>

              {
                client.tob && client.tob !== "" ?
                <React.Fragment>
                  <br/>
                  <div><Icon type="snippets" theme="filled" /> <b>Term</b></div>
                  <div style={{whiteSpace: "pre-wrap"}}>
                  {client.tob}
                  </div>
                </React.Fragment>
                :
                null
              }

              {
                client.tel && client.tel !== "" ?
                <React.Fragment>
                  <br/>
                  <div><Icon type="phone" theme="filled" /> <b>Landline</b></div>
                  <div>{client.tel}</div>
                </React.Fragment>
                :
                null
              }

              {
                client.address ?
                client.address.address1 !== "" || client.address.address2 !== ""
                || client.address.city !== "" || client.address.country !== "" || client.address.postcode !== "" ?
                <React.Fragment>
                  <br/>
                  <div><FontAwesomeIcon icon={faBuilding} />&nbsp;<b>Address</b></div>
                  {
                    client.address.address1 !== "" ?
                    <div>{client.address.address1}</div>
                    :
                    null
                  }
                  {
                    client.address.address2 !== "" ?
                    <div>{client.address.address2}</div>
                    :
                    null
                  }
                  {
                    client.address.city !== "" ?
                    <div>{client.address.city}</div>
                    :
                    null
                  }
                  {
                    client.address.country !== "" ?
                    <div>{client.address.country}</div>
                    :
                    null
                  }
                  {
                    client.address.postcode !== "" ?
                    <div>{client.address.postcode}</div>
                    :
                    null
                  }
                </React.Fragment>
                :
                null
                :
                null
              }
              
              {
                client.invoiceClientName && client.invoiceClientName !== "" ?
                <React.Fragment>
                  <br/>
                  <div><FontAwesomeIcon icon={faFileInvoiceDollar} />&nbsp;<b>Invoice Client Name</b></div>
                  <div>{client.invoiceClientName}</div>
                </React.Fragment>
                :
                null
              }

              {
                client.invoiceAddress && (client.invoiceAddress.address1 || client.invoiceAddress.address2
                || client.invoiceAddress.city || client.invoiceAddress.country || client.invoiceAddress.postcode) ?
                client.invoiceAddress.address1 !== "" || client.invoiceAddress.address2 !== ""
                || client.invoiceAddress.city !== "" || client.invoiceAddress.country !== "" || client.invoiceAddress.postcode !== "" ?
                <React.Fragment>
                  <br/>
                  <div><FontAwesomeIcon icon={faFileInvoiceDollar} />&nbsp;<b>Invoice Address</b></div>
                  {
                    client.invoiceAddress.address1 !== "" ?
                    <div>{client.invoiceAddress.address1}</div>
                    :
                    null
                  }
                  {
                    client.invoiceAddress.address2 !== "" ?
                    <div>{client.invoiceAddress.address2}</div>
                    :
                    null
                  }
                  {
                    client.invoiceAddress.city !== "" ?
                    <div>{client.invoiceAddress.city}</div>
                    :
                    null
                  }
                  {
                    client.invoiceAddress.country !== "" ?
                    <div>{client.invoiceAddress.country}</div>
                    :
                    null
                  }
                  {
                    client.invoiceAddress.postcode !== "" ?
                    <div>{client.invoiceAddress.postcode}</div>
                    :
                    null
                  }
                </React.Fragment>
                :
                null
                :
                null
              }
              </div>
            </Card>
          </div>
        </Col>
        <Col span={18}>
          <div style={{marginLeft: '5px'}}>
            <Tabs
              tabBarExtraContent={<div>
                Created By
                &nbsp;&nbsp;
                <CustomAvatar
                  colourCode={client.register.firstname.charAt(0).toLowerCase()}
                  char={`${client.register.firstname.charAt(0).toUpperCase()}${client.register.lastname.charAt(0).toUpperCase()}`}
                  charSize={14}
                  size={24}
                  src={`${s3.baseURL}/${process.env.REACT_APP_S3_BUCKET}/avatar/user/${client.register.id}.jpeg`}
                />
                &nbsp;at&nbsp;<span>{moment(client.createdAt).format('DD/MM/YY')}</span>
              </div>}
              onChange={() => {}}
              type="card"
            >
              <TabPane tab={
                <span><FontAwesomeIcon icon={faClipboard} /> Notes</span>
              } key="1">
                <div style={flexCenterRight}>
                  <Button type="primary" onClick={() => {
                    setShowNotesModal(true);
                  }}><Icon type="edit" /> Edit Notes</Button>
                </div>
                <br/>
                {
                  client.notes && client.notes !== "" ?
                  parse(client.notes)
                  :
                  <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
                }
              </TabPane>
              <TabPane tab={
                <span><FontAwesomeIcon icon={faFileInvoice} /> Offers <Badge count={client.offers.length} style={{ backgroundColor: '#B0BF1A' }} /></span>
              } key="7">
                <OffersList offers={client.offers} type="client" />
              </TabPane>
              <TabPane tab={
                <span><FontAwesomeIcon icon={faFileInvoiceDollar} /> Invoices <Badge count={client.invoices.length} style={{ backgroundColor: '#B0BF1A' }} /></span>
              } key="6">
                <InvoicesList invoices={client.invoices} type="client" />
              </TabPane>
              <TabPane tab={
                <span><FontAwesomeIcon icon={faUserFriends} /> Contacts <Badge count={client.contacts.length} style={{ backgroundColor: '#B0BF1A' }} /></span>
              } key="2">

                <Row>
                  <Col span={12}>
                    <Search
                      placeholder="Search"
                      onChange={e => setSearch(e.target.value)}
                      style={{ width: 200 }}
                    />
                  </Col>
                  <Col span={12}>

                   <CreateContactForm />

                    <div style={flexCenterRight}>
                      <Button type="primary" onClick={() => {
                        dispatch({
                          type: "SET_CREATE_CONTACT_MODAL",
                          payload: true
                        });
                      }}><Icon type="plus-square" /> New Contact</Button>
                    </div>
                  </Col>
                </Row>
                <br/>

                <Table
                  columns={columns}
                  dataSource={
                    search === "" ?
                    client.contacts.map(i => {
                      return {...i, ...{fullname: `${i.firstname} ${i.lastname}`}}
                    })
                    :
                    client.contacts.map(i => {
                      return {...i, ...{fullname: `${i.firstname} ${i.lastname}`}}
                    }).filter(e =>
                      e.fullname.toLowerCase().includes(search.toLowerCase()) ||
                      e.position.toLowerCase().includes(search.toLowerCase()) ||
                      e.department.toLowerCase().includes(search.toLowerCase())
                      )
                  }
                  rowKey="id"
                />
              </TabPane>
              <TabPane tab={
                <span><FontAwesomeIcon icon={faFileWord} /> Vacancy <Badge count={vacancyEvents.length} style={{ backgroundColor: '#B0BF1A' }} /></span>
              } key="5">
                <Row>
                  <Col span={24}>
                    <Spin spinning={vacancyLoading} indicator={<Icon type="loading" />}>
                      <List
                        dataSource={vacancyEvents}
                        renderItem={(item, index) => (
                          <List.Item>
                            <div style={{ width: "100%" }}>
                              {renderVacancyEvent(item, index+1)}
                            </div>
                          </List.Item>
                        )}
                      />
                    </Spin>
                  </Col>
                </Row>
              </TabPane>
              <TabPane tab={
                <span><FontAwesomeIcon icon={faFolderOpen} /> Docs</span>
              } key="3">

                <Spin spinning={driveRefetching} indicator={<Icon type="loading" />}>
                <Row>
                  <Col span={12}>
                    <Search
                      placeholder="Search"
                      onChange={e => setFileSearch(e.target.value)}
                      style={{ width: 200 }}
                    />
                  </Col>

                  <Col span={12}>
                    <div style={flexCenterRight}>
                      <Button type="primary" onClick={() => {
                        window.open(`https://drive.google.com/drive/folders/${client.driveFolderID}`,'_blank');
                        }}
                      >
                        <Icon type="google" /> Open Google Drive Folder
                      </Button>
                      &nbsp;&nbsp;
                      <Button type="primary" onClick={() => {
                        setShowUploadModal(true);
                      }}><Icon type="upload" /> Upload Documents</Button>
                    </div>
                  </Col>
                </Row>

                <br/>

                {
                  files.length > 0 ?
                  <Table
                    pagination={false}
                    columns={fileColumns}
                    dataSource={fileSearch === "" ?
                    files
                    :
                    files.filter(i => i.name.toLowerCase().includes(fileSearch.toLowerCase()))
                    }
                    rowKey="id"
                  />
                  :
                  <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
                }
                </Spin>

              </TabPane>
              <TabPane tab={
                <span><FontAwesomeIcon icon={faEdit} /> Edit Client</span>
              } key="4">
                <EditClientForm />
              </TabPane>
            </Tabs>
          </div>
        </Col>
      </Row>
    </div>
  );
}

export default Client;
